"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadService = void 0;
class UploadService {
    constructor(uploadService) {
        this.uploadService = uploadService;
    }
    async upload(url, method, file) {
        try {
            const uploadResult = await this.uploadService.upload({
                url: url,
                data: { file: file },
                method: method
            });
            file.result = uploadResult.data;
            file.percentageComplete = 100;
            return uploadResult;
        }
        catch (e) {
            file.percentageComplete = 0;
            file.error = {
                text: e.Message,
            };
        }
    }
}
exports.UploadService = UploadService;
UploadService.$inject = ['Upload'];
